import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { useLang } from "../context/LanguageContext";

const faqs = [
  { q: "Is een thuisbatterij rendabel zonder salderingsregeling?", a: "Absoluut. Door de afbouw van de saldering vanaf 2027 wordt eigen verbruik veel waardevoller. Een goed gedimensioneerde thuisbatterij verhoogt het eigen verbruik tot 75–90% en verkort de terugverdientijd aanzienlijk." },
  { q: "Hoe lang gaat een thuisbatterij mee?", a: "Premium batterijen zoals Tesla Powerwall, BYD en Huawei hebben 10 jaar fabrieksgarantie en gaan in de praktijk 15 tot 20 jaar mee bij normaal gebruik." },
  { q: "Hoe lang duurt de installatie?", a: "Een standaard installatie nemen we vaak in 1 dag in gebruik. Voor maatwerk configuraties (bv. zakelijk of 3-fase) kan dit oplopen tot 2 dagen." },
  { q: "Kan ik mijn bestaande zonnepanelen koppelen?", a: "Ja. Onze adviseurs bepalen op basis van je huidige omvormer of we een AC- of DC-gekoppelde batterij adviseren. We werken met vrijwel alle gangbare merken." },
  { q: "Welke subsidies zijn beschikbaar?", a: "Vanaf 2025 is er BTW-teruggave (21%) op de batterijinstallatie mogelijk. Daarnaast bieden meerdere provincies en gemeentes lokale subsidies. Wij regelen dit voor je." },
  { q: "Werkt de batterij ook bij stroomuitval?", a: "Ja, mits voorzien van een backup-module (zoals Tesla Backup Gateway). Je woning blijft dan automatisch werken tijdens een stroomuitval." },
];

const FAQSection = () => {
  const { t } = useLang();
  return (
    <section className="section-pad bg-slate-50/70" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand mb-3">{t.faq.eyebrow}</p>
          <h2 className="font-heading text-4xl md:text-5xl font-black tracking-tighter text-navy-900 text-balance">{t.faq.title}</h2>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-white border border-slate-200 rounded-2xl px-6 data-[state=open]:border-brand/40 data-[state=open]:shadow-[0_10px_30px_rgba(255,47,125,0.08)] transition-all"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-heading font-bold text-lg text-navy-900 hover:no-underline py-5 text-left">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
